<script setup lang="ts">
import { computed } from 'vue';
import { useGroupStore } from '@/stores/group';

import SettingsHeader from './SettingsHeader.vue';
import SettingsRow from './SettingsRow.vue';

const groupStore = useGroupStore();

const groupEmail = computed<string | null>(() => {
  return groupStore.group?.contact?.email || null;
});

const groupPhone = computed<string | null>(() => {
  return groupStore.group?.contact?.phone_number || null;
});
</script>

<template>
  <div class="page page--no-navbar">
    <div class="content contact-page">
      <SettingsHeader :title="$t('profile.contactNetwork')" />

      <section class="contact-page__section">
        <h2 class="contact-page__section-title">{{ $t('settings.contactInfo') }}</h2>
        <div class="contact-page__card">
          <SettingsRow
            v-if="groupEmail"
            :href="`mailto:${groupEmail}`"
            icon="mail"
            :label="groupEmail"
            trailing-icon="chevron-right"
          />
          <SettingsRow
            v-if="groupPhone"
            :href="`tel:${groupPhone}`"
            icon="phone"
            :label="groupPhone"
            trailing-icon="chevron-right"
          />
        </div>
      </section>
    </div>
  </div>
</template>

<style lang="scss">
.contact-page {
  background-color: $color-neutral-lower;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;

  &__section {
    padding: $spacing-5;
  }

  &__section-title {
    color: $color-neutral-highest;
    font: $heading-h4;
    letter-spacing: $heading-h4-spacing;
    margin: 0 0 $spacing-3;
  }

  &__card {
    background-color: $color-white;
    border-radius: $radius-xl;
    display: flex;
    flex-direction: column;
    overflow: hidden;
    border: 1px solid $color-border-medium;
  }
}
</style>
